<template>
    <div class="box">
        <van-nav-bar left-arrow @click-left="onClickLeft"  fixed='true' placeholder="true" />

        <div class="gradien">
            <div class="loginTitle">手机号登录</div>
            <div class="minTitle">未注册过的手机号将自动创建账号</div>
        </div>
        <div class="fields">
            <van-field v-model="username" name="手机号" placeholder="请输手机号" clearable />
            <div class="fg"><span v-if="!isValidPhone">手机号格式错误</span></div>
            <van-field v-model="identifying" center clearable placeholder="请输入验证码">
                <template #button>
                    <!-- <van-button size="small" type="primary">发送验证码</van-button> -->
                    <div class="fsLogin">
                        <div v-if="!isValidPhone && shows != 1">获取验证码</div>
                        <div class="fsLogin_a" v-if="isValidPhone && shows != 1" @click="simulateSendCode">获取验证码</div>
                        <div :class="countdown == 0 ? 'fsLogin_a' : 'fsLogin_b'" v-if="shows == 1"
                            @click="simulateSendCodes"><span class="fsLogin_a" v-if="countdown != 0">{{
            countdown
        }}s</span> 重新获取
                        </div>
                    </div>
                </template>
            </van-field>
            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit" class="loginbts"
                    v-if="isValidPhone && identifying.length > 0 && radio == 1">登录</van-button>
                <van-button round block type="info" native-type="submit" class="loginbt" v-else>登录</van-button>
            </div>
            <div class="groups">
                <div class="groups_a">
                    <van-radio-group v-model="radio" icon-size="14">
                        <van-radio name="1"></van-radio>
                    </van-radio-group>
                </div>
                <div>
                    登录及代表同意 <span class="groups_b">《用户协议》、《隐私协议》</span> 和
                </div>

            </div>
            <div class="groups_b">《中国联通认证服务协议》</div>
        </div>


    </div>

</template>

<script>
export default {
    data() {
        return {
            phoneNumber: '',
            verificationCode: '',
            countdown: 0,
            username: "15778411339",
            password: "",
            shows: 0,
            radio: 0,
            identifying: ""
        };
    },
    computed: {
        isValidPhone() {
            // 中国大陆手机号码正则表达式
            const regex = /^1[345789]\d{9}$/;
            return regex.test(this.username);
        }
    },
    methods: {
        sendCode() {
            // 这里应该是发送验证码到手机的逻辑
            this.simulateSendCode();
        },
        simulateSendCodes() {
            console.log('jjjj', this.countdown)
            if (this.countdown == 0) {
                this.simulateSendCode();
            }
        },
        simulateSendCode() {
            this.shows = 1;
            // 模拟倒计时
            this.countdown = 3;
            const intervalId = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown -= 1;
                } else {
                    clearInterval(intervalId);
                }
            }, 1000);
            // 模拟生成验证码
            const verificationCode = Math.floor(100000 + Math.random() * 900000).toString();
            console.log('生成的验证码:', verificationCode);
            // 这里应该将验证码发送给用户手机，并保存在服务器端以用于验证
        },
        onClickLeft() {
            this.$router.push({ path: '/membershipInterface' })
        }

    }
};
</script>

<style scopd>
.loginbt {
    background: rgba(255, 143, 31, 0.2);
    border: 0px solid #ccc;
}

.loginbts {
    background: #FF8F1F;
    border: 0px solid #ccc;
}

.groups {
    display: flex;
    font-size: 12px;
    justify-content: center;
}

.groups_a {
    padding-top: 2px;
    margin-right: 5px;
}

.groups_b {
    font-size: 12px;
    text-align: center;
    margin-top: 5px;
    color: #FF8F1F
}

.van-nav-bar__content {
    background-color: #FEF9E5;

}

.van-nav-bar .van-icon {
    color: #000;
}

.fsLogin {
    border-left: 1px solid #D8D8D8;
    padding-left: 5px;
    color: #aaa;
    font-size: 14px;
}

.fsLogin_a {
    color: #FF8F1F;
}

.box {
    font-family: MiSans;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0em;
    font-feature-settings: "kern" on;
    font-variation-settings: "opsz" auto;
    /* padding: 0 32px; */
}

.van-hairline--bottom::after {
    border-bottom-width: 0px;
}

.fields {
    padding: 0 32px;
}

.gradien {
    background: linear-gradient(to bottom, #FEF9E5, #ffffff);
    transition: background-image 2s ease;
}

.fg {
    height: 25px;
    font-size: 12px;
    padding-left: 10px;
    color: #EF0A24;
}

.van-field__body i {
    background: #F3F3F3;
    padding: 8px 0;
    padding-right: 15px;
}

.van-cell {
    padding: 0;

}

.van-cell::after {
    border: 0px solid #ccc;
}

.van-field__control {
    background: #F3F3F3;
    padding: 8px 10px;
    /* margin-bottom: 20px; */

}

.van-field__button {
    background: #F3F3F3;
    padding: 8px 10px;
}

.loginTitle {
    font-size: 18px;
    color: #3D3D3D;
    text-align: center;
    padding-top: 60px;
    font-weight: 600;
}

.minTitle {
    font-size: 12px;
    color: #767676;
    text-align: center;
    margin-top: 5px;
    margin-bottom: 21px;
}

.login-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

input {
    margin: 10px;
    padding: 8px;
}

button {
    margin: 10px;
    padding: 10px 20px;
}
</style>